// extracted by mini-css-extract-plugin
module.exports = {"content":"leave-modal_content__15RGq"};